import dynamic from 'next/dynamic';

import { DashboardLayoutFallback } from './dashboard-layout-skeleton';

/**
 * The dashboard shell, loaded on demand. Only /dashboard/* renders it, and a static import used to put
 * dashboard-sidebar, protected-page-layout and their dependencies in the bundle every public page
 * downloads.
 *
 * The `loading` fallback matters because this layout wraps the page component: without it a client-side
 * navigation from a public page renders null for the whole viewport — no header, no sidebar, no content —
 * until the chunk lands. `error ? null` keeps a post-deploy chunk 404 from pinning a full-screen
 * placeholder over a page that would otherwise still work.
 *
 * No companion prefetch here on purpose. Warming this chunk from the buttons that route into the dashboard
 * would mean importing this module from the header, and `dashboard-layout` imports the header — a cycle
 * that import/no-cycle rejects even through a dynamic import. The paths that reach the dashboard all cross
 * an authentication round trip anyway (`me()`, or create + login), which covers the chunk download on its
 * own, so the skeleton below is where the actual win is.
 */
export const LazyDashboardLayout = dynamic(() => import('./dashboard-layout'), { loading: ({ error }) => (error ? null : <DashboardLayoutFallback />) });
